import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthorizationService } from 'services/authorization.service';

export const KEY_CLIENT_DATA_UPDATE_REQUIRED = 'clientDataUpdateRequired';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthorizationService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.authService.isAuthenticated()) {
      await this.authService.fetchUserSecurityInfo();

      return true;
    }
    this.authService.setRedirectUrl(state.url);
    this.router.navigate(['/login']);

    return false;
  }
}
